var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4 mb-3"},[_c('v-img',{staticClass:"image-cropper-galleryphoto",attrs:{"src":_vm.imgURL}}),_c('v-spacer'),(_vm.caption)?_c('v-card-title',{staticClass:"justify-center custom-font",staticStyle:{"font-size":"large"}},[_vm._v("\n  "+_vm._s(_vm.caption)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }